import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-13/task-01";

const task: Slide = {
  title: "Give the unit of a geophone sensitivity in the  International System of Units.",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
